<template>
  <div class="animated fadeIn">
    <!-- loading component -->
    <Loading />
    <b-col cols="8" class="border-0 m-auto">
      <b-card class="border-0 shadow">
        <!-- NOTE header  -->
        <h2>افزودن پژوهشگر جدید</h2>

        <hr />
        <!-- NOTE getting researcher info  -->
        <b-form-group id="name" label="*نام:" label-for="name">
          <b-form-input
            trim
            id="name"
            required
            placeholder
            v-model="name"
            type="text"
          ></b-form-input>
        </b-form-group>
        <b-form-group id="name" label="*نام‌خانوادگی:" label-for="lastName">
          <b-form-input
            trim
            id="lastName"
            required
            placeholder
            v-model="lastName"
            type="text"
          ></b-form-input>
        </b-form-group>
        <b-form-group id="name" label="*شماره موبایل:" label-for="name">
          <b-form-input
            trim
            id="mobile"
            required
            placeholder
            v-model="mobile"
            type="number"
            :no-wheel="true"
          ></b-form-input>
        </b-form-group>
        <b-row class="mb-2">
          <b-col>
            <span>دانشگاه محل تحصیل</span>
          </b-col>
          <b-col class="text-left">
            <b-form-checkbox
              id="checkbox-1"
              v-model="university.id"
              name="checkbox-1"
              :value="notUniversity"
              unchecked-value=""
              @change="reactivity = !reactivity"
            >
              سایر دانشگاه ها
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <Select2
                v-model="university.id"
                :options="universities"
                :settings="{ width: '100%' }"
                :disabled="university.id == notUniversity"
              ></Select2>
              <b-form-input
                trim
                class="mt-1"
                v-model="university.other"
                v-show="university.id == notUniversity"
                placeholder="نام دانشگاه مورد نظر"
                @input="reactivity = !reactivity"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-button
          variant="success"
          :disabled="!(name && mobile && lastName)"
          class="mt-3"
          @click="newUser()"
          >ثبت</b-button
        >
      </b-card>
    </b-col>
  </div>
</template>

<script>
import Select2 from "v-select2-component";
export default {
  components: {
    Select2,
  },
  data: function () {
    return {
      name: "",
      lastName: "",
      mobile: "",
      universities: [],
      university: {},
      reactivity: false,
      isBusy: false,
    };
  },

  methods: {
    newUser() {
      this.isbusy = true;
      this.$bvModal.show("loading");
      this.$http
        .post(
          this.baseUrl + "/setad/admin/researcher/new",
          {
            name: this.name,
            lastName: this.lastName,
            mobile: this.mobile,
            universityId: this.university.id,
            universityOther: this.university.other,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 201) {
            this.isbusy = false;
            this.toast(res.data, "success");
            localStorage.setItem("newUser", JSON.stringify(true));
            this.$router.push("/admin/users");
            this.$bvModal.hide("loading");
          }
        })
        .catch((err) => {
          this.isbusy = false;
          console.log(err);
          this.toast(err.response.data, "error");
          this.$bvModal.hide("loading");
        });
    },
    onMounted() {
      this.$http
        .post(
          this.baseUrl + "/setad/options/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universities = res.data;
          this.universities.push(
            new Object({
              id: this.notUniversity,
              text: "سایر دانشگاه ها",
            })
          );
          this.universities.unshift({
            id: 0,
            text: "--گزینه مورد نظر خود را انتخاب نمایید--",
            disabled: "true",
          });
          this.$bvModal.hide("loading");
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
  },

  mounted() {
    this.onMounted();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
